<template>
    <b-modal
        v-on:ok="saveItem"
        v-on:hide="closeModal"
        v-on:cancel="closeModal"
        :visible="status"
        :no-close-on-backdrop="true"
        body-class="p-3 text-left"
        size="lg" title="Form">
        <p v-if="loading">Loading...</p>
        <form-component v-else
            :timestamp="localTimestamp"
            :type="_.get(localContent, 'type')"

            :id="_.get(localContent, 'id')"
            :attributes="_.get(localContent, 'attributes', {})"
            :meta="_.get(localContent, 'meta', {})"
            :schema="_.get(localContent, 'schema.attributes', {})"
            :config="formConfig"
            :resourceParams="resourceParams"

            :changeUrl="doNothing"
            :changeSection="doNothing"
            :changeQuery="doNothing"

            :addNotification="addNotification"

            :createData="modifiedCreateData"
            :updateData="modifiedUpdateData"
            :deleteData="deleteData"
            :commitQueue="doNothing"
            :pushQueue="doNothing"

            :onInitialized="registerSubmit"
            :onChanged="updateLocalContent"
            :onCreated="onCreated"
            :onUpdated="onUpdated"
            :onDeleted="doNothing"
            ></form-component>
    </b-modal>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';

import FormComponent from '../FormComponent';

export default {
    data() {
        return {
            formSubmit: this.doNothing,
            localContent: {},
            localTimestamp: Date.now(),
            contentErrors: {},
            dirty: false,
        }
    },

    props: ['endpoint', 'config'],

    components: {
        FormComponent,
    },

    mounted() {
        if (this.endpoint) {
            return this.getInitialData(this.endpoint)
        }
    },

    watch: {
        timestamp(ts) {
            this.localContent = _.cloneDeep(this.content);
            this.localTimestamp = ts;
            this.dirty = false;
        }
    },

    computed: {
        ...Vuex.mapGetters('sub', {
            content: 'content',
            parent: 'parent',
            timestamp: 'timestamp',
            resourceParams: 'resourceParams',
            status: 'status',
            loading: 'loading',
        }),

        formConfig() {
            return _.get(this.config, 'formConfig', {});
        },
    },

    methods: {
        ...Vuex.mapActions('sub', [
            'getInitialData',
            'createData',
            'updateData',
            'deleteData',

            'changeUrl',
            'changeQuery',
            'changeSection',
            'changePath',
            'setContent',
            'setStatus',
        ]),

        ...Vuex.mapActions([
            'addNotification',
            'addToCollection',
            'updateCollection',
        ], { root: true }),

        closeModal() {
            console.log('closing');
            console.trace();
            this.setStatus(false);
        },

        openModal() {
            console.log('opening');
            this.setStatus(true);
        },

        saveItem(e) {
            e.preventDefault();

            this.formSubmit();
            const errors = _.chain(this.contentErrors)
                .toPairs().filter(([name, error]) => error).size().value();

            if (errors) {
                // keep this modal open
                this.openModal();
            } else {
                this.closeModal();
            }
        },

        doNothing(e) {
            // console.log(e);
        },

        // modify top level API methods so that
        // they accept multiple arguments instead of just 1
        modifiedCreateData(data, options) {
            return this.createData({ data, options });
        },

        modifiedUpdateData(data, options) {
            return this.updateData({ data, options });
        },

        registerSubmit(type, name, payload) {
            this.formSubmit = _.get(payload, 'submit', this.doNothing);
        },

        updateLocalContent(payload) {
            this.localContent.attributes = _.merge(this.localContent.attributes, payload.data);
            this.localContent.updateBatch = {  ...payload.updateBatch };
            this.contentErrors = payload.errors;

            this.dirty = true;
        },

        onCreated(type, res) {
            this.addToCollection(res);
        },

        onUpdated(type, res) {
            this.updateCollection([res]);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/FormModalComponent.vue